import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import FuelEnergyContentFactorImportLineService from "../../../../shared/services/fuel-energy-content-factor-import-line/fuel-energy-content-factor-import-line.service";
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, Tab, Tabs, Tooltip, useMediaQuery } from '@mui/material';
import { CustomTabPanel } from '../../../presentation-components/display-elements-components/custom-tab-panel';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import { SuperAdminEnergyConversionFormField } from '../../../presentation-components/super-admin/super-admin-energy-conversion-form-field';
import { InformationBox } from '../../../presentation-components/miscellaneous-components/information-box';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';
import ConversionService from '../../../../shared/services/conversion/conversion.service';
import { IConversion } from '../../../../shared/services/conversion/conversion.model';
import { secrSourceLabelForKey } from '../../../../shared/constants/secr-reporting-sources';
import { SuperAdminSecrMappingCard } from '../../../presentation-components/super-admin/super-admin-secr-mapping-card';
import { IConversionSource } from '../../../../shared/services/conversion-source/conversion-source.model';
import ConversionSourceService from '../../../../shared/services/conversion-source/conversion-source.service';
import SquareFootConversionService from '../../../../shared/services/square-foot-conversion/square-foot-conversion.service';
import SpendBasedConversionService from '../../../../shared/services/spend-based-conversion/spend-based-conversion.service';
import gaiaTheme from '../../../../root-components/theme';
import { SearchBar } from '../../../presentation-components/display-elements-components/search-bar';
import { useDebounce } from '../../../../hooks/use-debounce-hook';

export const SuperAdminConversionFactorsCommittedPage = () => {
  const { year, conversionSourceId } = useParams();
  //Services
  const fuelEnergyContentService = new FuelEnergyContentFactorImportLineService();
  const conversionService = new ConversionService();
  const conversionSourceService = new ConversionSourceService();
  const squareFootConversionService = new SquareFootConversionService();
  const spendBasedConversionService = new SpendBasedConversionService();
  const userNotificationsContext = useContext(UserNotificationsContext);
  //State
  const [conversionSource, setConversionSource] = useState<IConversionSource>()
  const [conversions, setConversions] = useState<any[]>([]);
  const [secrConversion, setSecrConversion] = useState<IConversion | null>(null);
  const [tab, setTab] = useState(0);
  const [fuelOptions, setFuelOptions] = useState<any[]>();
  const [searchQuery, setSearchQuery] = useState<string>('');
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [orderBy, setOrderBy] = useState<string>();
  const [order, setOrder] = useState<'asc' | 'desc'>();
  const [change, setChange] = useState<number>(0)
  //Loading State
  const [hasPageMounted, setHasPageMounted] = useState<boolean>(false)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));  

  useEffect(() => {
    if (conversionSourceId) {
      conversionSourceService.getOne(conversionSourceId)
        .then(response => {
          setConversionSource(response);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }, [conversionSourceId]);

  useEffect(() => {
    if (tab === 0) {
      getConversions();
    } else if (tab === 1) {
      getEnergyContentLines();
    }
  }, [inputPage, perPage, change, conversionSource, debouncedSearchQuery]);

  useEffect(() => {
    if (hasPageMounted) {
      if (inputPage === 0) {
        setChange(change + 1)
      } else {
        setInputPage(0)
      }
    }
    setHasPageMounted(true)
  }, [tab, order, orderBy, year, conversionSourceId, debouncedSearchQuery])


  const getConversions = () => {
    if (year && conversionSource) {
      const resolvedConversionType: 'conversion' | 'squareFootConversion' | 'spendBasedConversion' = (conversionSource.conversionType as any) ?? 'conversion';
      if (resolvedConversionType === 'conversion') {
        conversionService
          .getConversionsForConversionSourceWithPagination(
            conversionSource.id,
            year,
            debouncedSearchQuery,
            inputPage,
            perPage,
            orderBy,
            order,
          )
          .then(response => {
            setConversions(response.rows);
            setTotalRecords(response.count);
          })
          .catch(error => {
            console.error(error);
          });
      } else if (resolvedConversionType === 'squareFootConversion') {
        squareFootConversionService
          .getSquareFootConversionsForConversionSourceWithPagination(
            conversionSource.id,
            year,
            debouncedSearchQuery,
            inputPage,
            perPage,
            orderBy,
            order,
          )
          .then(response => {
            setConversions(response.rows);
            setTotalRecords(response.count);
          })
          .catch(error => {
            console.error(error);
          });
      } else if (resolvedConversionType === 'spendBasedConversion') {
        spendBasedConversionService
          .getSpendBasedConversionsForConversionSourceWithPagination(
            conversionSource.id,
            year,
            debouncedSearchQuery,
            inputPage,
            perPage,
            orderBy,
            order,
          )
          .then(response => {
            setConversions(response.rows);
            setTotalRecords(response.count);
          })
          .catch(error => {
            console.error(error);
          });
      }
    }
  };



  // const getConversions = () => {
  //   if (conversionSourceId && year) {
  //     conversionService.getConversionsForConversionSourceWithPagination(conversionSourceId, year, '', inputPage, perPage, orderBy, order)
  //       .then(response => {
  //         setRecords(response.rows);
  //         setTotalRecords(response.count);
  //         setConversionSource(response.conversionSource);
  //       })
  //       .catch(error => {
  //         console.error(error);
  //         setRecords([]);
  //       });
  //   }
  // }

  const getEnergyContentLines = () => {
    if (conversionSourceId && year) {
      fuelEnergyContentService.getAll(`?conversionSourceId=${conversionSourceId}&year=${year}`)
        .then((response) => {
          setFuelOptions(response)
        })
        .catch(() => {
          console.log('error')
          setFuelOptions([])
        });
    }
  }

  const formatCommittedSecrStatus = (c: IConversion) => {
    const s = c.secrSourceMappingStatus;
    if (s === 'confirmed') return 'Confirmed';
    if (s === 'suggested') return 'Suggested';
    if (s === 'unmapped') return 'Unmapped';
    return '—';
  };

  const headCellsConversion: IHeadCell[] = [
    { id: 'scope', numeric: false, label: 'Scope', sortable: false },
    { id: 'detailLevelOne', numeric: false, label: 'Level One', sortable: true },
    { id: 'detailLevelTwo', numeric: false, label: 'Level Two', sortable: true },
    { id: 'detailLevelThree', numeric: false, label: 'Level Three', sortable: true },
    { id: 'detailLevelFour', numeric: false, label: 'Level Four', sortable: true },
    { id: 'detailLevelFive', numeric: false, label: 'Level Five', sortable: true },
    { id: 'measurementUnit', numeric: false, label: 'Unit of Measurement', sortable: true },
    { id: 'energyContentFactor', numeric: true, label: 'Energy Content Factor', sortable: false },
    { id: 'volumeMassConverter', numeric: true, label: 'Volume/Mass Converter', sortable: false },
    { id: 'multiplier', numeric: true, label: 'Multiplier', sortable: true },
    { id: 'greenHouseGasUnit', numeric: false, label: 'Greenhouse Gas Unit', sortable: true },
    { id: 'secrStatus', numeric: false, label: 'SECR status', sortable: false },
    { id: 'secrSuggested', numeric: false, label: 'SECR suggested', sortable: false },
    { id: 'secrReporting', numeric: false, label: 'SECR reporting', sortable: false },
    { id: 'secrMapping', numeric: false, label: 'SECR', sortable: false, align: 'center' },
  ];

  const rowsConversion = !conversions ? [] : conversions.map((conversion) => ({
    id: conversion.id,
    scope: conversion.scope,
    detailLevelOne: conversion.detailLevelOne,
    detailLevelTwo: conversion.detailLevelTwo,
    detailLevelThree: conversion.detailLevelThree,
    detailLevelFour: conversion.detailLevelFour,
    detailLevelFive: conversion.detailLevelFive,
    measurementUnit: conversion.measurementUnit.name,
    greenHouseGasUnit: conversion.greenHouseGasUnit.name,
    energyContentFactor: conversion.energyContentFactor,
    volumeMassConverter: conversion.volumeMassConverter,
    multiplier: conversion.multiplier,
    secrStatus: formatCommittedSecrStatus(conversion),
    secrSuggested: secrSourceLabelForKey(conversion.secrSourceSuggestedKey),
    secrReporting:
      conversion.secrSourceMappingStatus === 'confirmed'
        ? secrSourceLabelForKey(conversion.secrSourceKey)
        : '—',
    secrMapping: (
      <Tooltip title='Set SECR reporting source'>
        <IconButton
          size='small'
          aria-label='Set SECR reporting source'
          onClick={(e) => {
            e.stopPropagation();
            setSecrConversion(conversion);
          }}
        >
          <EditNoteOutlinedIcon fontSize='small' />
        </IconButton>
      </Tooltip>
    ),
  }))

  const headCellsSquareFoot: IHeadCell[] = [
    { id: 'activity', numeric: false, label: 'Activity', sortable: true },
    { id: 'consumptionTypeCode', numeric: false, label: 'Consumption Type', sortable: true },
    { id: 'measurementUnit', numeric: false, label: 'Unit of Measurement', sortable: true },
    { id: 'multiplier', numeric: true, label: 'Multiplier', sortable: true },
    { id: 'greenHouseGasUnit', numeric: false, label: 'Greenhouse Gas Unit', sortable: true },
  ];

  const rowsSquareFoot = !conversions
    ? []
    : conversions.map(conversion => {
      return {
        id: conversion.id,
        activity: conversion.activity,
        consumptionTypeCode: conversion.consumptionTypeCode === 'GAS' ? 'Gas' : 'Electricity',
        measurementUnit: conversion.measurementUnit.name,
        multiplier: conversion.multiplier,
        greenHouseGasUnit: conversion.greenHouseGasUnit.name,
      };
    });

  const headCellsSpendBased: IHeadCell[] = [
    { id: 'localAuthorityCustomIdentifier', numeric: false, label: 'Code', sortable: false },
    { id: 'activity', numeric: false, label: 'Activity', sortable: false },
    { id: 'category', numeric: false, label: 'Category', sortable: false },
    { id: 'measurementUnit', numeric: false, label: 'Unit', sortable: true },
    { id: 'greenHouseGasUnit', numeric: false, label: 'GHG Unit', sortable: true },
    { id: 'multiplier', numeric: true, label: 'Multiplier', sortable: true },
  ];


  const rowsSpendBased = !conversions ? [] : conversions.map((conversion) => {
    return {
      id: conversion.id,
      localAuthorityCustomIdentifier: conversion.localAuthorityCustomIdentifier,
      activity: `${conversion.activity}`,
      category: conversion.category?.friendlyName || conversion.category?.name || '—',
      measurementUnit: conversion.measurementUnit.name,
      greenHouseGasUnit: conversion.greenHouseGasUnit.name,
      multiplier: conversion.multiplier,
    };
  });

  const handleOrderChange = (newOrderBy: string, newOrder: 'asc' | 'desc') => {
    setOrderBy(newOrderBy);
    setOrder(newOrder);
  };

  const submitHandler = (id: string, fuelType: string, kwhKg?: number, kwhL?: number) => {
    fuelEnergyContentService.edit(id, { fuelType, kwhKg, kwhL })
      .then(() => {
        userNotificationsContext?.openSnackbar({ open: true, message: 'Updated successfully' });
        getEnergyContentLines();
      })
      .catch((error) => {
        userNotificationsContext?.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        console.error(error);
      });
  }


  return (
    <PageOuterContainer>
      {conversionSource &&
        <PageHeading title={`Committed ${conversionSource.source}, ${year}`} includeBackButton backButtonLink={`/super-admin/conversion-factors/${conversionSourceId}?tabId=1`} backButtonText='Back to years' />}
      <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label='Conversion Factors' />
        <Tab label='Energy Content Factors' />
      </Tabs>
      <CustomTabPanel value={tab} index={0}>
        {conversionSource && (
          <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
              <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
            </Grid>
          </Grid>
        )}
        {conversionSource &&
          <TableDisplay
            onOrderChange={handleOrderChange}
            isMobileMode={isMobileMode}
            headCells={(conversionSource.conversionType ?? 'conversion') === 'conversion' ? headCellsConversion : (conversionSource.conversionType ?? 'conversion') === 'squareFootConversion' ? headCellsSquareFoot : headCellsSpendBased}
            rows={(conversionSource.conversionType ?? 'conversion') === 'conversion' ? rowsConversion : (conversionSource.conversionType ?? 'conversion') === 'squareFootConversion' ? rowsSquareFoot : rowsSpendBased}
            selectByIcon={true}
            selected={selected}
            setSelected={setSelected}
            inputPage={inputPage}
            setInputPage={setInputPage}
            totalRecords={totalRecords}
            perPage={perPage}
            setPerPage={setPerPage} />}
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={1}>
        <Box>
          {fuelOptions &&
            <>
              {fuelOptions.length === 0 ?
                <InformationBox
                  text="There are no energy content factors you need to apply"
                  icon={IconName.CheckCircleOutlined}
                />
                :
                fuelOptions
                  .sort((a, b) => a.fuelType.localeCompare(b.fuelType))
                  .map((fuel: any) => (
                    <SuperAdminEnergyConversionFormField
                      key={fuel.id}
                      fuel={fuel}
                      submitHandler={submitHandler}
                    />
                  ))
              }
            </>
          }
        </Box>
      </CustomTabPanel>
      <Dialog open={secrConversion != null} onClose={() => setSecrConversion(null)} maxWidth='sm' fullWidth>
        <DialogTitle>SECR reporting source</DialogTitle>
        <DialogContent>
          {secrConversion && (
            <SuperAdminSecrMappingCard
              conversionId={secrConversion.id}
              suggestedKey={secrConversion.secrSourceSuggestedKey}
              secrSourceKey={secrConversion.secrSourceKey}
              status={secrConversion.secrSourceMappingStatus}
              onSaved={() => {
                setSecrConversion(null);
                getConversions();
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </PageOuterContainer>
  )

}